module.exports = "../../app/cells/components/modals/setup_wizard/weekly_commitment.erb";